module.exports = __webpack_public_path__ + "static/media/crashcar.8f65afbf.png";